"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useFirstEvent_1 = require("./useFirstEvent");
Object.defineProperty(exports, "useFirstEvent", { enumerable: true, get: function () { return useFirstEvent_1.default; } });
